<script setup>

</script>

<template>
  <div class="flex-container">
    <div class="flex-item">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
html, body {
  margin: 0;
  height: 100%;
}

.flex-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中（可选） */
  height: 100vh; /* 高度固定为视口高度 */
  overflow: hidden; /* 隐藏溢出内容 */
}

.flex-item {
  height: 100vh; /* 高度固定为容器高度 */
  //aspect-ratio: 16 / 9; /* 16:9 比例 */
  width: 100vw;
  max-width: 100%; /* 防止宽度超出屏幕 */
}
</style>